import React from "react";
import { SelectInput, SimpleForm, Button, ArrayField, Toolbar, SaveButton, Edit, Create, Datagrid, TextField,
	BooleanField, FormDataConsumer, ReferenceArrayInput, AutocompleteArrayInput, ReferenceInput, AutocompleteInput,
	required } from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';
const {AUDIT_STATUS} = require('./components/audit_status');

const ShareEntityToolbar = props => (
	<Toolbar {...props} >
		<SaveButton label=" Copy Entity " redirect="edit" submitOnEnter={false} />
	</Toolbar>
);
const entityChoices = [
	{id: 'pub_report', name: 'Earning Report'},
	{id: 'carbon_pub_report', name: 'Analytics Report'},
	{id: 'discrepancies', name: 'Discrepancy Report'},
	{id: 'adquality_reports', name: 'Ad Quality Report'},
	{id: 'campaign', name: 'Campaign'}
];
export const ShareEntityCreate = (props) => (
	<Create title="Share Entity" {...props}>
		<SimpleForm toolbar={<ShareEntityToolbar />}>
		  <SelectInput label="Entity" source="entity" choices={entityChoices} validate={required()} style={{width: '20%'}}/>
			<FormDataConsumer>
			{({ formData }) => (formData && formData.entity==='pub_report') &&
				<div style={{width: '40%'}}>
				<ReferenceInput source="source" label="Select Earning Report" 
					reference="pubreports"
					basePath='pubreports'
					sort={{ field: 'name', order: 'ASC' }}
					filter={{}}
					filterToQuery={searchText => ({ search_name: searchText })}
					validate={required()}
					fullWidth
					>
					<AutocompleteInput optionValue="code" 
					optionText={record => (record && record.name)?`${record.name} (${record.code})`:""} style={{ width: '100%' }}/>
				</ReferenceInput>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer>
			{({ formData }) => (formData && formData.entity==='carbon_pub_report') &&
				<div style={{width: '40%'}}>
				<ReferenceInput source="source" label="Select Analytics Report" 
					reference="carbon/pubreports"
					basePath='carbon/pubreports'
					sort={{ field: 'name', order: 'ASC' }}
					filter={{}}
					filterToQuery={searchText => ({ search_name: searchText })}
					validate={required()}
					fullWidth
					>
					<AutocompleteInput optionValue="code" 
					optionText={record => (record && record.name)?`${record.name} (${record.code})`:""} style={{ width: '100%' }}/>
				</ReferenceInput>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer>
			{({ formData }) => (formData && formData.entity==='discrepancies') &&
				<div style={{width: '40%'}}>
				<ReferenceInput source="source" label="Select Discrepancies Report" 
					reference="discrepancies"
					basePath='discrepancies'
					sort={{ field: 'name', order: 'ASC' }}
					filter={{}}
					filterToQuery={searchText => ({ search_name: searchText })}
					validate={required()}
					fullWidth
					>
					<AutocompleteInput optionValue="code" 
					optionText={record => (record && record.name)?`${record.name} (${record.code})`:""} style={{ width: '100%' }}/>
				</ReferenceInput>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer>
			{({ formData }) => (formData && formData.entity==='adquality_reports') &&
				<div style={{width: '40%'}}>
				<ReferenceInput source="source" label="Select Ad Quality Report" 
					reference="adquality_reports"
					basePath='adquality_reports'
					sort={{ field: 'name', order: 'ASC' }}
					filter={{}}
					filterToQuery={searchText => ({ search_name: searchText })}
					validate={required()}
					style={{ width: '100%' }}
					>
					<AutocompleteInput optionValue="code" 
					optionText={record => (record && record.name)?`${record.name} (${record.code})`:""} style={{ width: '100%' }}/>
				</ReferenceInput>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer>
			{({ formData }) => (formData && formData.entity==='campaign') &&
				<div style={{width: '40%'}}>
				<ReferenceInput source="source" label="Select Campaign/Traffic Rule/Ad Quality Rule" 
					reference="campaigns"
					basePath='campaigns'
					sort={{ field: 'name', order: 'ASC' }}
					filter={{}}
					filterToQuery={searchText => ({ search_name: searchText })}
					validate={required()}
					style={{ width: '100%' }}
					>
					<AutocompleteInput optionValue="code" 
					optionText={record => (record && record.name)?`${record.name} (${record.code})`:""} style={{ width: '100%' }}/>
				</ReferenceInput>
				</div>
			}
			</FormDataConsumer>
			<div style={{width: '40%'}}>
			<ReferenceArrayInput source="destination"
				reference="users"
				basePath="users"
				perPage={15}
				sort={{ field: 'name', order: 'ASC' }}
				filter={{}}
				filterToQuery={searchText => ({ search_name: searchText })}
				allowEmpty 
				validate={required()}
				fullWidth>
				<AutocompleteArrayInput label="Users"
					optionText={choice => choice && choice.name ? `${choice.name} / ${choice.username} (${choice.role})` : ''}
					optionValue="code" style={{ width: '100%' }} />
			</ReferenceArrayInput>
			</div>
		</SimpleForm>
	</Create>
);

const EmptyToolbar = props => (
	<Toolbar {...props} >
		<Button href="/#/share/" label="Back..." variant="contained" color="primary" startIcon={<EditIcon />} />
	</Toolbar>
);
export const ShareEntityEdit = (props) => (
	<Edit title="Results" {...props} >
		<SimpleForm toolbar={<EmptyToolbar />} >
			<BooleanField source="success" label="Success?" />
			<ArrayField source="messages" label="Messages" style={{ width: '100%' }} >
				<Datagrid>
					<TextField source="message" />
				</Datagrid>
			</ArrayField>
		</SimpleForm>
	</Edit>
);
